export default __webpack_public_path__ + "static/futuristic_blockchain-241cd66fb75728bbc357982138d34e3c.webp";